"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var classNames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Modal'), recompose_1.pure);
/**
 * @deprecated do not use this wrapper
 */
exports.default = enhance(function (props) {
    var isOpen = props.isOpen, name = props.name, onClose = props.onClose, headerLabel = props.headerLabel, children = props.children, _a = props.buttons, buttons = _a === void 0 ? [
        {
            label: 'sok/modal/generic/close',
            onClick: function () { return props.onClose && props.onClose(); }
        }
    ] : _a;
    return (React.createElement(sok_ui_1.Modal, { overlayClassName: classNames(name && "sok-generic-modal-overlay-".concat(name)), isOpen: isOpen, className: classNames('sok-generic-modal', name && "sok-generic-modal-".concat(name)) },
        React.createElement(sok_ui_1.Header, { className: 'header', onClose: function () { return onClose && onClose(); } }, (0, translation_1.getLocalization)(headerLabel || 'sok/modal/generic/header')),
        React.createElement(sok_ui_1.Container, { className: 'content' }, children),
        React.createElement(sok_ui_1.Footer, { className: 'footer' }, buttons.map(function (button, i) { return (React.createElement(sok_ui_1.Button, { key: "modal-button-".concat(i), color: button.color, onClick: function () { return button.onClick && button.onClick(); }, text: (0, translation_1.getLocalization)(button.label) })); }))));
});
